<template>
  <el-dialog :visible.sync="state" :title="plustitle" width="600px" :close-on-click-modal="false" @closed="handleClose" append-to-body>
    <div class="m-form">
      <el-form class="ghost-button-styles" label-width="140px" @submit.native.prevent>
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="landData.type" @change="changeType">
            <el-radio-button ghost label="all" :disabled="edit">通用文案</el-radio-button>
            <el-radio-button ghost label="game" :disabled="edit">关联游戏</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="游戏组" prop="group" v-if="isGameType">
          <el-select v-model="landData.group" filterable :popper-append-to-body="false" style="width: 100%">
            <el-option v-for="item in groupList" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="游戏（可多选）" prop="game" v-if="isGameType">
          <el-select v-model="landData.games" filterable:popper-append-to-body="false" multiple style="width: 100%" clearable collapse-tags>
            <el-option v-for="item in gamesList" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文案内容">
          <el-input
            v-model="landData.docContent"
            type="textarea"
            style="width: 100%"
            rows="8"
            placeholder="文案一行一个,每条文案不超过120个字符"
          />
          <p class="g-error-text" v-if="!edit">注: 文案一行一个,每条文案不超过120个字符</p>
          <div v-show="rows && !edit">
            共<span class="g-error-text">{{ rows }}</span
            >条文案
          </div>
        </el-form-item>
      </el-form>
    </div>

    <template #footer>
      <div class="m-foot">
        <el-button @click="emit('input', false)">取消</el-button>
        <el-button type="primary" :loading="loading" @click="save">
          <span v-if="loading">提交中...</span>
          <span v-else>确认</span>
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, reactive, computed, watch, nextTick, onMounted, defineProps, defineEmits } from 'vue'
import { Message } from 'element-ui'
import { trim } from '@/common/js/utils'
import { initPageData, ALL_GAMES, GAME_GROUPS } from '@/data/global-opts'

const PAGE_REQUIRED_OPTS = initPageData([ALL_GAMES, GAME_GROUPS])
const props = defineProps({
  value: Boolean,
  title: String,
  loading: {
    type: Boolean,
    default: false
  },
  info: Object,
  edit: {
    type: Boolean,
    default: false
  }
  // gamesList: Array,
  // groupList: Array
})

const gamesList = computed(PAGE_REQUIRED_OPTS.ALL_GAMES)
const groupList = computed(PAGE_REQUIRED_OPTS.GAME_GROUPS)

const emit = defineEmits(['input', 'on-save'])

const landData = reactive({
  docContent: '',
  group: '',
  games: [],
  type: 'game'
})

const isGameType = computed(() => props.info.type === 'game')

const state = computed({
  get: () => props.value,
  set: (val) => emit('input', val)
})

const plustitle = computed(() => `${props.edit ? '修改' : '新增'}${props.title}`)

const rows = computed(() => {
  return landData.docContent && landData.docContent.split(/\r?\n/).filter((ret) => trim(ret)).length
})

watch(
  () => props.info,
  (nVal) => {
    updateInfo()
  },
  { deep: true }
)

// Re-implement bindGetData correctly for Element UI
const handleClose = () => {
  landData.docContent = ''
  landData.group = ''
  landData.games = []
  landData.type = 'game'
}

// Actually, let's look at the original logic again.
// if (e) return. -> If e is true (visible), return. So do nothing when opening.
// When e is false (hidden), reset landData.
// So I should use @close or @closed on el-dialog.
// I'll add @closed="handleClose" to el-dialog.

const changeType = () => {
  landData.group = ''
  landData.games = []
}

const updateInfo = () => {
  if (props.info) {
    const info = JSON.parse(JSON.stringify(props.info))
    Object.assign(landData, info)
  }
}

const save = () => {
  if (!landData.docContent) {
    Message.error('文案内容不能为空！')
    return
  }
  if (isGameType.value && !landData.games.length) {
    Message.error('未选择关联游戏！')
    return
  }
  emit('on-save', landData)
}

onMounted(() => {
  nextTick(updateInfo)
})
</script>

<style lang="scss" scoped>
// .c-docs {
//   position: relative;

//   .m-form {
//     overflow-y: auto;
//     scrollbar-width: thin;
//     -webkit-overflow-scrolling: touch;
//     max-height: 480px;
//   }
// }
</style>
